<template>
  <div class="d-flex justify-content-start gap-2" :class="{ 'sql-chosen-sticky-button': isListExpanded }">
    <div v-if="!isReadView && !showListOnStart" class="mb-2" :name="fieldName">
      <el-button type="primary" :disabled="disabled" @click="expandList">{{ checkSelectedRows }}</el-button>
    </div>
    <common-anchor-button v-if="isRouteUrl" v-bind="buttonProps" @click-create-new-element="emitNewElement" />
  </div>
</template>

<script>
import CommonAnchorButton from '../../list/buttonList/CommonAnchorButton'
import EventBus from '../../../utils/event-bus'
import { cloneDeep, get, isEmpty } from 'lodash'

export default {
  name: 'SqlChosenControlButtons',
  components: {
    CommonAnchorButton,
  },
  props: {
    isReadView: {
      type: Boolean,
      default: false,
    },
    mongoId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      closedState: {
        hamburgerMenu: false,
        pagination: false,
        limitation: true,
        tableHeader: true,
        visibleUnselectedRows: false,
        search: false,
        rowSelection: true,
        expandRow: false,
        aggregation: false,
      },
      openState: {
        hamburgerMenu: true,
        pagination: true,
        limitation: true,
        tableHeader: true,
        visibleUnselectedRows: true,
        search: true,
        rowSelection: true,
        expandRow: false,
        aggregation: true,
      },
      showMoreType: {
        noItem: this.$i18n.t('sqlchoosen_button_no_item'), // nincs elem kivalasztva
        fewItems: this.$i18n.t('sqlchoosen_button_few_items'), // kevesebb elem van kiválasztva mint a page limit
        lotOfItems: this.$i18n.t('sqlchoosen_button_lot_of_items'), // több elem van kiválasztva mint a page limit
        closed: this.$i18n.t('sqlchoosen_button_closed'), // összecsukott lista: eleme kiválasztása
      },
    }
  },
  computed: {
    buttonProps() {
      return get(this.sqlChosenButtonProps, 'buttonProps', {})
    },
    checkSelectedRows() {
      if (!this.isListExpanded) {
        return this.showMoreType.closed
      } else {
        if (this.rowLength === 0) {
          return this.showMoreType.noItem
        } else if (this.rowLength < this.expandedListLimit) {
          return this.showMoreType.fewItems
        } else {
          return this.showMoreType.lotOfItems
        }
      }
    },
    disabled() {
      return this.$get('disabled')
    },
    extendedVisibilityProps() {
      return this.$get('extendedVisibilityProps')
    },
    extraOptions() {
      return this.$get('extraOptions')
    },
    expandedListLimit() {
      return get(this.sqlChosenButtonProps, 'sqlExpandedLimit')
    },
    fieldName() {
      return this.$get('fieldName')
    },
    formId() {
      return this.$get('mongoId')
    },
    id() {
      return this.$get('id')
    },
    isListExpanded: {
      get() {
        return this.visibilityState({ key: 'isExpanded' })
      },
      set(isListExpanded) {
        this.$dispatch('setVisibility', {
          key: 'isExpanded',
          value: !!isListExpanded,
        })
      },
    },
    isRouteUrl() {
      return get(this.sqlChosenButtonProps, 'isRouteUrl')
    },
    rowLength() {
      return !isEmpty(this.selectedRows) ? this.selectedRows.length : 0
    },
    selectedRows() {
      return this.$get('selectedRows')
    },
    selectedRowsFilter: {
      get() {
        return this.$get('selectedRowsFilter')
      },
      set(selectedRowsFilter) {
        this.$dispatch('setSelectedRowsFilter', { selectedRowsFilter })
        EventBus.$emit(`apply-filter-${this.id}`, { id: this.id, type: 'button' })
      },
    },
    showListOnStart() {
      return this.$get('showListOnStart')
    },
    sqlChosenButtonProps() {
      return this.$get('sqlChosenButtonProps')
    },
    visibilityOptions() {
      return this.$get('listVisibilityOptions')
    },
    visibilityState() {
      return this.$get('visibilityState')
    },
  },
  methods: {
    emitNewElement() {
      EventBus.$emit('click-create-new-element')
    },
    expandList() {
      this.isListExpanded = !this.isListExpanded
      this.selectedRowsFilter = this.isListExpanded ? 'normal' : 'selected'

      this.setVisibilityState()
    },
    setVisibilityState() {
      const visibilityOptions = cloneDeep(this.visibilityOptions)
      const options = Object.assign(visibilityOptions, this.isListExpanded ? this.openState : this.closedState)
      this.$dispatch('setListVisibilityOptions', { options })
      EventBus.$emit(`reset-filter-${this.id}`, { id: this.id, refreshLocalStore: true })
    },
  },
  created() {
    this.selectedRowsFilter = 'selected'
  },
  mounted() {
    this.setVisibilityState()

    if (this.showListOnStart) this.expandList()
  },
}
</script>

<style scoped lang="scss">
.sql-chosen-sticky-button {
  position: sticky;
  top: 65px;
  left: 0;
  z-index: 2;
}
</style>
